import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { experimentalStyled } from '@material-ui/core/styles';
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';

const DashboardLayoutRoot = experimentalStyled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.paper,
  display: 'flex',
  height: '100%',
  overflow: 'hidden',
  width: '100%'
}));

const DashboardLayoutWrapper = experimentalStyled('div')(({ theme, issidebareopen }) => {
  return {
    height: "100%",
    display: 'flex',
    flex: '1 1 auto',
    minWidth: 0,
    paddingTop: '64px',
    transition: "padding-left 225ms cubic-bezier(0, 0, 0.2, 1)",
    [theme.breakpoints.up('lg')]: {
      paddingLeft: issidebareopen === "true" ? '256px' : 'initial'
    }
  }
});

const DashboardLayoutContainer = experimentalStyled('div')({
  display: 'flex',
  flex: '1 1 auto',
  height: "100%",
  overflow: 'hidden'
});

const DashboardLayoutContent = experimentalStyled('div')({
  flex: '1 1 auto',
  // Sem isto o item flex alarga ate a largura das tabelas largas e o container corta-as em vez de fazerem scroll
  minWidth: 0,
  height: '100%',
  position: 'relative',
  WebkitOverflowScrolling: 'touch'
});

const DashboardLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  return (
    <DashboardLayoutRoot>
      <DashboardSidebar
        onCloseSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
        openSidebar={isSidebarOpen}
      />
      <DashboardNavbar onSidebarOpen={() => setIsSidebarOpen(!isSidebarOpen)} />
      <DashboardLayoutWrapper issidebareopen={isSidebarOpen.toString()}>
        <DashboardLayoutContainer>
          <DashboardLayoutContent>
            <Outlet />
          </DashboardLayoutContent>
        </DashboardLayoutContainer>
      </DashboardLayoutWrapper>
    </DashboardLayoutRoot>
  );
};

export default DashboardLayout;
